import { render, staticRenderFns } from "./CreateFeaturedSchool.vue?vue&type=template&id=55ef9e7c&"
import script from "./CreateFeaturedSchool.vue?vue&type=script&lang=js&"
export * from "./CreateFeaturedSchool.vue?vue&type=script&lang=js&"
import style0 from "./CreateFeaturedSchool.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports